<template>
  <v-container class="py-10" id="wissen">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#005a85">Herausforderungen</div>
        <h2>Wissen und Ressourcen</h2>
        <p>
          Die Nutzung neuer IT-Anwendung benötigt Ressourcen und Wissen. Wie
          sind soziale Organisationen in diesem Kontext aufgestellt? Von den
          Befragten gaben <b>33%</b> an, dass ihre Organisation das notwendige
          Wissen hat. Weitere <b>33%</b> gaben an, bedingte Expertise zu haben.
          Auf der anderen Seite geben <b>57%</b> der Organisationen an, nicht
          genug Ressourcen für die Anwendung neuer Tools zu haben.
        </p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{ name: 'methodology' }"
            >
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span>Stichprobe &amp; Methoden</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              aria-hidden="true"
              v-on="on"
              :to="{
                name: 'comparison',
                query: { var: 'IT: Wissen und Ressourcen' }
              }"
            >
              <v-icon>mdi-chart-line</v-icon>
            </v-btn>
          </template>
          <span>Zum Analyse-Tool</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Wissen",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "heatmap"
        },

        title: {
          text: "Um neue IT-Anwendungen zu nutzen, haben die Organisationen... "
        },

        xAxis: {
          categories: [
            "nicht genug Ressourcen",
            "befriedigende Ressourcen",
            "genug Ressourcen"
          ]
        },

        yAxis: {
          categories: [
            "genug Wissen",
            "bedingtes Wissen",
            "nicht genug Wissen"
          ],
          title: null,
          reversed: true
        },

        colorAxis: {
          min: 0,
          max: 35,
          minColor: "#FFFFFF",
          maxColor: "#005a85"
        },
        legend: {
          enabled: false,
          align: "right",
          layout: "vertical",
          margin: 0,
          verticalAlign: "top",
          y: 25,
          symbolHeight: 280
        },

        tooltip: {
          formatter: function() {
            return (
              this.series.xAxis.categories[this.point.x] +
              " und " +
              this.series.yAxis.categories[this.point.y] +
              ": " +
              this.point.value +
              "%"
            );
          }
        },

        series: [
          {
            name: "Sales per employee",
            borderWidth: 1,
            borderColor: "white",
            data: [
              [0, 0, 10.0],
              [0, 1, 13.6],
              [0, 2, 33.6],
              [1, 0, 8.6],
              [1, 1, 14.1],
              [1, 2, 2.4],
              [2, 0, 14.4],
              [2, 1, 2.1],
              [2, 2, 1.1]
            ],
            dataLabels: {
              enabled: true,
              color: "#000000",
              format: "{point.value}%",

              style: {
                fontSize: "12px",
                fontWeight: "normal",
                textOutline: "none"
              }
            }
          }
        ],

        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "wissenundressourcen",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
